<template>
	<bread-crumb list-classes="breadcrumb-links breadcrumb-dark">
		<BreadCrumbItem>
			<router-link to="/home" custom v-slot="{navigate}">
				<a @click="navigate" @keypress.enter="navigate" role="link"
					><i class="fas fa-home text-dark"></i>&nbsp; &nbsp; &nbsp;<span class="text-primary">Home</span>
				</a>
			</router-link>
		</BreadCrumbItem>
		<BreadCrumbItem
			v-for="(route, index) in $route.matched.slice()"
			:key="route.name"
			:active="index === $route.matched.length - 1"
			style="display: inline-block"
		>
			<router-link
				custom
				v-slot="{navigate}"
				class="text-primary"
				:to="{name: route.name}"
				v-if="index < $route.matched.length - 1"
			>
				<span @click="navigate" @keypress.enter="navigate" role="link"> / </span>
			</router-link>
			<span v-else class="text-dark">{{ route.name }}</span>
		</BreadCrumbItem>
	</bread-crumb>
</template>

<script>
import BreadCrumb from "./Breadcrumb";
import BreadCrumbItem from "./BreadcrumbItem";

export default {
	name: "route-breadcrumb",
	components: {
		BreadCrumb,
		BreadCrumbItem,
	},
	methods: {
		getBreadName(route) {
			return route.name;
		},
	},
};
</script>
